import { render, staticRenderFns } from "./KernelOrderAttributes.vue?vue&type=template&id=312c877a&"
import script from "./KernelOrderAttributes.vue?vue&type=script&lang=js&"
export * from "./KernelOrderAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports